// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "-" + {"21": "ded267f40e4cdace","917": "72c3c789326d6226",}[chunkId] + ".js"
}